module.exports = __webpack_public_path__ + "img/c06_unittechsiegetowerchampion_Normal_ua.2575a640.webp";